import {api2Endpoint} from 'app/config/apiConfig'
import errorNotify from 'app/hooks/api/utils/errorNotify'
import {IProjectInvitation} from 'interfaces/IProjectInvitation'
import {useMutation} from 'react-query'
import {postData} from '../api/usePostData'
import {announceSend} from '../api/utils/announce'

interface Args {
  project_invitation: IProjectInvitation
}

export function useAcceptProjectInvitation() {
  return useMutation(async (args: Args) => {
    try {
      ///api2/std/delegate_invitation/{id}/accept
      const route = `std/project_invitation/${args.project_invitation.id}/accept`
      announceSend('post', route, args.project_invitation.project_id)
      const retval = await postData<unknown>(
        api2Endpoint(route),
        {project_id: args.project_invitation.project_id, role: args.project_invitation.role},
        'post'
      )
      announceSend('post', route, args.project_invitation.project_id)
      return retval
    } catch (err) {
      errorNotify(err, 'Could not accept invitation.')
    }
  })
}
